import { axiosPost } from './axiosService';

const feedbackUrl = `/Lenders/me/Feedback`;

export class FeedbackService {
	submitFeedback(form) {
		return axiosPost(form, feedbackUrl, {
			'Content-Type': 'multipart/form-data',
		});
	}
}
